import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=c64f1b42&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./Product.vue?vue&type=style&index=1&id=c64f1b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64f1b42",
  null
  
)

export default component.exports